import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/SiteChrome";

export const inputCls = "w-full h-12 px-4 rounded-xl border border-[#DFD5C5] bg-white focus:outline-none focus:ring-2 focus:ring-[#C5A880]";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative grain">
        <img src="https://images.unsplash.com/photo-1532712938310-34cb3982ef74?w=1400&q=80&fm=jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
      </div>
      <div className="flex flex-col px-6 py-8 sm:px-12">
        <Logo />
        <div className="flex-1 flex items-center">
          <div className="w-full max-w-md mx-auto py-10 space-y-8">
            <div className="space-y-2">
              <h1 className="font-display text-4xl sm:text-5xl font-light">{title}</h1>
              {subtitle && <p className="text-[#6C6560]">{subtitle}</p>}
            </div>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav(sp.get("next") || (data.role === "admin" ? "/admin" : "/nadzorna-plosca"));
    } catch (er) { toast.error(errMsg(er, "Prijava ni uspela.")); }
    setBusy(false);
  };

  return (
    <AuthShell title="Prijava" subtitle="Dostop do vajine poročne nadzorne plošče.">
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <input className={inputCls} type="email" placeholder="E-poštni naslov" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
        <input className={inputCls} type="password" placeholder="Geslo" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
        <button disabled={busy} className="btn-dark w-full h-12 disabled:opacity-50" data-testid="login-submit-button">{busy ? "Prijavljanje …" : "Prijava"}</button>
        <Link to="/pozabljeno-geslo" className="block text-sm text-center underline text-[#B39264]" data-testid="login-forgot-link">Pozabljeno geslo?</Link>
      </form>
      <p className="text-sm text-[#6C6560]">Še nimata poroke? <Link to="/ustvari" className="underline text-[#B39264]" data-testid="login-create-link">Ustvarita jo</Link>. Gostje za ogled galerije ne potrebujejo prijave.</p>
    </AuthShell>
  );
}
